

// COPY BUTTONS
function copySelectionToClipboard() {
  // console.log('* copy to clipboard');
  // http://www.javascriptkit.com/javatutors/copytoclipboard.shtml
  var copysuccess; // var to check whether execCommand successfully executed
  try {
    copysuccess = document.execCommand("copy"); // run command to copy selected text to clipboard
    // console.log(typeof document.execCommand);
    // document.execCommand("copy");
  } catch (error) {
    copysuccess = false;
  }
  return copysuccess;
}
//
const _copy = (e, ref) => {
  // console.log('* copy');
  if (ref && ref.current) {
    const target = ref.current;
    target.select(); // SELECT TEXT IN THE FILED
    copySelectionToClipboard(); // COPY TO CLIPBOARD
  }
};


//
export const useCopyInputSelectionToClipboard = () => {
  //
  return {
    // copySelectionToClipboard: copySelectionToClipboard,
    _copy: _copy
  };
};